import { PlusSquareOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { DraggableActionsButton } from '../../../inputs/common/option-list/style/DraggableActionsButton.tsx';
import { WidgetOptionStructure } from '../../../inputs/common/option-list/style/WidgetOptionStructure.tsx';
import { WidgetRepository } from '../../../WidgetRepository.ts';
import { type ITableColumnWidget } from '../ITableInputWidget.ts';

const LabelCol = styled.div`
  width: 30%;
  padding: 0 4px;
`;
const WidgetCol = styled.div`
  width: 35%;
  padding: 0 4px;
  font-style: italic;
`;
const CodeCol = styled.div`
  width: 35%;
  font-family: monospace;
  font-weight: 600;
  padding: 0 4px;
  font-size: 0.9em;
  word-wrap: break-word;
`;
const WidgetType = styled.div`
  display: flex;
  align-items: center;
  /* font-size: 16px; */
  .anticon {
    margin-right: 8px;
    font-size: 20px;
  }
`;

export interface ITableColumnViewProps {
  item: ITableColumnWidget;
  listeners?: any;
  onEdit?: (e: any) => void;
  onRemove?: (e: any) => void;
  onAdd?: (e: any) => void;
}

export function TableColumnView(props: ITableColumnViewProps) {
  const { item, listeners, ...actions } = props;

  const widget = WidgetRepository.find(item.type);

  return (
    <WidgetOptionStructure
      listeners={listeners}
      actions={<DraggableActionsButton {...actions} />}
    >
      <WidgetCol>
        {widget && (
          <WidgetType>
            {widget.icon ?? <PlusSquareOutlined />} {widget.name ?? widget.type}
          </WidgetType>
        )}
      </WidgetCol>
      <LabelCol>
        <RichTextAdvancedRender inline text={item.label} />
      </LabelCol>
      <CodeCol>{item.code}</CodeCol>
    </WidgetOptionStructure>
  );
}
